import axios, {
  AxiosHeaders,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
import { toast } from "react-toastify";
import { GestaoResponse } from "../agendamento.types";

/* =====================================================
   ENV
===================================================== */

const { REACT_APP_URL_EASY_GESTAO } = process.env;

/* =====================================================
   AXIOS INSTANCE
===================================================== */

const api: AxiosInstance = axios.create({
  baseURL: REACT_APP_URL_EASY_GESTAO ?? "http://localhost:8787",
  timeout: 60_000,
  headers: {
    "Content-Type": "application/json",
  },
});

/* =====================================================
   REQUEST INTERCEPTOR (X-S)
===================================================== */

api.interceptors.request.use((config) => {
  const xSession = sessionStorage.getItem("X-S");

  if (xSession) {
    if (!config.headers) {
      config.headers = new AxiosHeaders();
    }

    if (config.headers instanceof AxiosHeaders) {
      config.headers.set("X-S", xSession);
    }
  }

  return config;
});

/* =====================================================
   RESPONSE INTERCEPTOR (ERRO GLOBAL)
===================================================== */

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.title ||
      "Erro ao comunicar com o servidor";

    toast.error(message, { autoClose: 5000 });

    return Promise.reject(error);
  }
);

/* =====================================================
   SERVICE API (DESENVELOPA dataResponse)
===================================================== */

const ServiceAPI = {
  async get<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const res = await api.get<GestaoResponse<T>>(url, config);
    return res.data.dataResponse;
  },

  async post<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const res = await api.post<GestaoResponse<T>>(url, data, config);
    return res.data.dataResponse;
  },

  async put<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const res = await api.put<GestaoResponse<T>>(url, data, config);
    return res.data.dataResponse;
  },

  async delete<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const res = await api.delete<GestaoResponse<T>>(url, config);
    return res.data.dataResponse;
  },
};

export default ServiceAPI;
